export default __webpack_public_path__ + "static/media/Vine_Lane.0625b269.svg";